import http from '../../core/services/http'

export const generateMenusInProbingStatusReport = ({ includeOnlyStuckMenus }) =>
  http.get(
    `/reports/menus-in-probing-status?includeOnlyStuckMenus=${includeOnlyStuckMenus}`,
    { responseType: 'blob' },
  )
